import { render, staticRenderFns } from "./CustomerPage.vue?vue&type=template&id=ac50a51c&scoped=true"
import script from "./CustomerPage.vue?vue&type=script&lang=js"
export * from "./CustomerPage.vue?vue&type=script&lang=js"
import style0 from "./CustomerPage.vue?vue&type=style&index=0&id=ac50a51c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac50a51c",
  null
  
)

export default component.exports